import { register } from '@shopify/theme-sections'
import { Carousel } from '../modules/carousel'
import '../../styles/sections/index-hero-category.scss'


export default register(`index-hero-category`, {
  onLoad() {

    Carousel()

  },

  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload() {
  },
})

